import { render, staticRenderFns } from "./AuthSidebar.vue?vue&type=template&id=d400b2b6"
import script from "./AuthSidebar.vue?vue&type=script&lang=ts"
export * from "./AuthSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports